// theme/theme.ts
import "./fonts/fonts.css"; // ✅ This loads the font for use in your theme

import { createTheme } from "@mui/material/styles";
import { heIL } from "@mui/material/locale";

const colors = {
  black: "#000000",
  green: "#01F156",
  gray: "#606060",
  red: "#FF0000",
  white: "#FFFFFF",
  lightGrey: "#F8F8F8",
  svgGrey: "#BFBFBF",
  errorRed: "#BE2626",
};

const theme = createTheme(
  {
    direction: "rtl",
    palette: {
      primary: { main: colors.green, contrastText: colors.black },
      secondary: { main: colors.gray, contrastText: colors.white },
      error: { main: colors.errorRed },
      background: { default: colors.lightGrey, paper: colors.white },
      text: { primary: colors.black, secondary: colors.gray },
    },
    typography: {
      fontFamily: "'Almoni'",
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            fontWeight: 700,
          },
        },
      },
      MuiInputBase: {
        styleOverrides: { root: { fontSize: "1.2rem" } },
      },
      MuiInputLabel: {
        styleOverrides: { root: { fontSize: "1.2rem" } },
      },
    },
  },
  heIL, // Hebrew localization
);

export default theme;
